import * as api from '../api';
import { actionTypes } from 'redux-resource';
import { SubmissionError } from 'redux-form';
import { PER_PAGE } from 'helpers/actions';

export const fetchSqlReports =
  (page = 1) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'sqlReports',
      requestKey: `fetchSqlReports_${page}`,
      list: `fetchSqlReports_${page}`,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchSqlReports(page)
      .then((response) => {
        const { count, next, previous, results } = response.data;
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: results || [],
          requestProperties: {
            perPage: (results && results.length) || PER_PAGE,
            count,
            next,
            previous,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
          requestProperties: {
            message: err.response && err.response.details,
          },
        });
      });
  };

export const findSqlReport = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'sqlReports',
    requestKey: 'findSqlReport',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .findSqlReport(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
        statusCode: err.response && err.response.status,
      });
    });
};

export const updateSqlReport = (id, attrs) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'sqlReports',
    requestKey: 'updateSqlReport',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .updateSqlReport(id, attrs)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });
      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      if (messages.detail) {
        throw new SubmissionError({ _error: messages });
      } else if (messages.message || messages.error) {
        throw new SubmissionError({
          _error: messages.message || messages.error,
        });
      } else {
        throw new SubmissionError(messages);
      }
    });
};
